import {doc, setDoc, getDoc, collection, query, where, getDocs} from "firebase/firestore";
import {db} from "@/main";

export async function GetGroupData() {
    return new Promise(async (resolve, reject) => {
        const groupDataRef = collection(db, "groupData");

        const groupDataQuery = query(
            groupDataRef
        );

        const groupDataSnapshot = await getDocs(groupDataQuery);

        if (!groupDataSnapshot.empty) {
            
            const returnGroupData = [];
            for (const groupData of groupDataSnapshot.docs) {
                returnGroupData.push({...groupData.data()});
            }
            resolve(returnGroupData);

        } else {
            reject("No matching Groups found!");
        }
    });
}

export async function SetGroupDatatoEmploy(cycleid: string, data: object) {
    console.log("Set", cycleid, data)
    const employRef = collection(db, "employ")
    const employDataQuery = query(
        employRef,
        where("cycleid", "==", cycleid)
    )
    const employDataSnapshot = await getDocs(employDataQuery);

    if (!employDataSnapshot.empty) {
        for (const employData of employDataSnapshot.docs) {
            setDoc(doc(db, "employ", employData.id), data, { merge: true });
        }
    }
    return true
}
